import React from "react";
import { type ReactNode } from "react";
import { useBreakpointValue } from "@chakra-ui/react";
import { TextTitle, type TextTitleProps } from "ui/text";
import { AuraPlate } from "ui/plates";
import { type BrandColorVariants } from "theme/colors";
import { BookDemoButton } from "../event-tracking";

export type FooterCTAProps = {
  variant: keyof BrandColorVariants;
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  maxW?: TextTitleProps["maxW"];
  descriptionMaxW?: TextTitleProps["maxW"];
};

export function FooterCTA({
  title = "Get a personalized demo",
  description = "Meet with an implementation expert to learn how Hightouch can help you achieve your top business priorities.",
  actions,
  variant,
  maxW = "680px",
  descriptionMaxW,
}: FooterCTAProps) {
  const responsiveDescription = useBreakpointValue({
    base: undefined,
    lg: description,
  });

  return (
    <AuraPlate
      theme="dark"
      variant={variant}
      py="0"
      plateMaxW="section"
      platePx={{ base: "small", lg: "biggest" }}
      platePy={{ base: "biggest", md: "huge" }}
    >
      <TextTitle
        theme="dark"
        size="xl"
        align="center"
        mobileAlign="center"
        maxW={maxW}
        descriptionMaxW={descriptionMaxW}
        title={title}
        description={responsiveDescription}
        actions={actions ?? <BookDemoButton />}
      />
    </AuraPlate>
  );
}
